module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTopMessage),
      expression: "isShowTopMessage"
    }],
    staticClass: "message-nav"
  }, [_c('img', {
    attrs: {
      "src": _vm.icon_notice,
      "width": "14"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "m_title"
  }, [_vm._v(_vm._s(_vm.message.title))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.handleShow
    }
  }, [_vm._v("点击查看")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }), _vm._v(" "), _c('messageDialog', {
    ref: "m_dialog",
    on: {
      "close": _vm.handleCloseDialog
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71bdd5ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/MessageNav/MessageNav.vue
// module id = 755
// module chunks = 8